module.exports = __webpack_public_path__ + "static/media/angle-down.50f3aa0d.svg";